import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    mergeFormData,
    objectToFormData,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { deleteConfirmModal } from "../../../helpers/DeleteValidate";

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
};

export const GraduationEAD = createSlice({
    name: "GraduationEAD",
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },
    },
});

export const {
    setPagination,
    clearPagination,
    setPaginationRequests,
    clearPaginationRequests,
} = GraduationEAD.actions;

export default GraduationEAD.reducer;

export const startGetReportGraduationRequirements = ({
    page = 1,
    query = "",
    number_rows = 25,
    curriculum_ids,
    cycle,
    hasDebts,
    hasCompleteDocumentation,
    hasAllCreditsCompleted,
    hasHighAverage,
    hasLowsStatus,
    hasNoFailedSubjects,
    hasEquivalentsSubjects,
    hasCompletedSocialService,
    isForeigner,
    isMexican,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);

        if (curriculum_ids) {
            params.set("curriculum_ids", curriculum_ids);
        }
        if (cycle) {
            params.set("cycle", `${cycle.year}-${cycle.sub_cycle}`);
        }

        params.set("hasDebts", Number(hasDebts));
        params.set(
            "hasCompleteDocumentation",
            Number(hasCompleteDocumentation)
        );
        params.set("hasAllCreditsCompleted", Number(hasAllCreditsCompleted));
        params.set("hasHighAverage", Number(hasHighAverage));
        params.set("hasLowsStatus", Number(hasLowsStatus));
        params.set("hasNoFailedSubjects", Number(hasNoFailedSubjects));
        params.set("hasEquivalentsSubjects", Number(hasEquivalentsSubjects));
        params.set(
            "hasCompletedSocialService",
            Number(hasCompletedSocialService)
        );
        params.set("isForeigner", Number(isForeigner));
        params.set("isMexican", Number(isMexican));

        const resp = await Call(
            `operators/graduation-ead/requirements/report`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPagination(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
